import { render } from "./TheToDanPho.vue?vue&type=template&id=fdc572fc"
import script from "./TheToDanPho.vue?vue&type=script&lang=js"
export * from "./TheToDanPho.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__